/* ZAKDOR - the order form, as a popup.

   One narrow card, one thing on screen at a time:

     1  the number, and the code that proves it
     2  how to pay
     3  where it goes
     4  handing over

   Cash on Delivery is a real order written by our app once the number is
   confirmed. Paying online opens Razorpay right here, inside the popup,
   and ends on our own confirmation screen; only if the app has no
   Razorpay keys does it fall back to Shopify's checkout.

   Two lines below are the ones worth changing by hand: the logo, and the
   line that teases the next order. Nothing else needs touching for those.

   If the app is switched off or unreachable, nothing is intercepted and
   every button behaves exactly as it does today. */
(function () {
  if (window.__axBuyFlow) return;
  window.__axBuyFlow = 1;

  /* ---- the two lines you would normally want to change ---- */

  /* The file is a 1536x1024 square with a lot of empty space around the
     mark, so the CDN is asked for a wide band out of its middle. That is
     what makes it read as a wordmark in a 60px tall bar instead of a stamp.
     Swap the part before the "?" for any other file and it keeps working. */
  var LOGO_FILE = 'https://cdn.shopify.com/s/files/1/0832/7387/5715/files/real_zakdor_inverse_logo_7b938d75-f756-4351-ac0f-158fa1cd225a.png';
  var LOGO = LOGO_FILE + '?v=1788098101&width=760&height=230&crop=center';
  var MARK = 'https://cdn.shopify.com/s/files/1/0832/7387/5715/files/zak.png?v=1788084957&width=260';

  var NEXT_CODE  = 'NEXT5';
  /* the pay-online code for a one-item order; the app's own code (Rs 20 on
     each item) takes over from two items up */
  var PRE1 = 'PREPAID30';
  var NEXT_OFFER = 'Use code ' + NEXT_CODE + ' on your next order and save 5%';

  var API = '/apps/track/buy';
  var CFG = null;

  /* Whether the app is switched on, and the pay-online code it uses. One
     request, asked once, and everything this file does is gated on it. */
  function boot() {
    return fetch(API + '?json=1', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.ok && j.enabled) {
          CFG = j;
          if (j.logo) { LOGO = j.logo; MARK = j.logo; }
        }
      })
      .catch(function () {});
  }
  /* A click can still land before the answer does. It is held instead: the
     app is asked, and the popup opens a moment later. If the app really is
     off or unreachable, the checkout is where the shopper was going anyway,
     so nothing is ever stuck. */
  var booting = null;
  function begin() { if (!booting) booting = boot(); return booting; }

  function ready() {
    if (CFG) return Promise.resolve(true);
    return Promise.race([
      begin().then(function () { return !!CFG; }),
      new Promise(function (go) { setTimeout(function () { go(!!CFG); }, 2500); })
    ]);
  }

  /* As soon as the page's own markup is parsed - not after every image on
     it has finished downloading. fetch() does not hold the browser's loading
     indicator, so there was nothing to wait for, and waiting meant a shopper
     on a slow phone could reach the cart and press Checkout before the app
     had been asked anything at all. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin);
  else begin();

  /* The cart's discount box - opening it, and colouring it for a dark cart -
     belongs to ax-offers.js, which owns every offer on the site. It used to
     be opened from here as well; two scripts reaching for the same <details>
     meant a shopper who folded it away had it pushed back open. */

  /* ---------------------------------------------------------------- */
  /*  look and feel                                                    */
  /* ---------------------------------------------------------------- */

  var CSS = ''
  + '.zkb-ov{position:fixed;inset:0;z-index:2147483004;background:rgba(5,11,24,.86);display:none;'
  +   'overflow-y:auto;-webkit-overflow-scrolling:touch;padding:22px 14px}'
  + '.zkb-ov.on{display:block;animation:zkb-fade .18s ease both}'
  + '@keyframes zkb-fade{from{opacity:0}to{opacity:1}}'
  + '.zkb-p{max-width:470px;margin:0 auto;background:#F6F8FB;border-radius:18px;overflow:hidden;'
  +   'color:#0A1730;font-family:inherit;box-shadow:0 40px 90px rgba(2,6,16,.55);'
  +   'animation:zkb-rise .3s cubic-bezier(.16,1,.3,1) both}'
  + '@keyframes zkb-rise{from{opacity:0;transform:translateY(20px) scale(.985)}to{opacity:1;transform:none}}'
  + '.zkb-p *{box-sizing:border-box}'

  /* header */
  + '.zkb-hd{position:relative;display:flex;align-items:center;justify-content:center;gap:10px;'
  +   'background:#fff;border-bottom:1px solid #E7EBF3;padding:14px 52px;min-height:64px}'
  + '.zkb-hd img{height:38px;width:auto;display:block;max-width:230px;object-fit:contain}'
  + '.zkb-wm{font-size:19px;font-weight:800;letter-spacing:.06em;color:#0A1730}'
  + '.zkb-hd .sl{display:flex;align-items:center}'
  + '.zkb-hd .nav{position:absolute;top:50%;transform:translateY(-50%);width:32px;height:32px;'
  +   'border:1px solid #E7EBF3;background:#fff;color:#5A6779;border-radius:9px;cursor:pointer;display:grid;'
  +   'place-items:center;padding:0;font-family:inherit;transition:background .15s,color .15s}'
  + '.zkb-hd .nav:hover{background:#F1F4F9;color:#0A1730}'
  + '.zkb-hd .bk{left:13px}.zkb-hd .cl{right:13px}'
  + '.zkb-hd .bk.off{visibility:hidden}'

  /* the two thin bands under the header */
  + '.zkb-next{display:flex;align-items:center;justify-content:center;gap:8px;padding:10px 14px;'
  +   'background:#000;color:#fff;font-size:12px;font-weight:700;text-align:center;letter-spacing:.01em}'
  + '.zkb-next svg{color:#FFC94A;flex:0 0 auto}'
  + '.zkb-nx{display:block;height:17px;overflow:hidden;flex:0 1 auto;min-width:0}'
  + '.zkb-nx u{display:block;text-decoration:none;transition:transform .55s cubic-bezier(.4,0,.2,1)}'
  + '.zkb-nx b{display:block;height:17px;line-height:17px;font-weight:700;white-space:nowrap;'
  +   'overflow:hidden;text-overflow:ellipsis}'
  + '.zkb-saved{display:flex;align-items:center;justify-content:center;gap:8px;padding:11px 14px;'
  +   'background:#DFF5E7;color:#0F7A3D;font-size:13px;font-weight:700;text-align:center}'

  + '.zkb-body{padding:14px;animation:zkb-step .22s ease both}'
  + '@keyframes zkb-step{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}'
  + '.zkb-card{background:#fff;border:1px solid #E7EBF3;border-radius:14px;padding:14px;margin-bottom:12px}'
  + '.zkb-card:last-child{margin-bottom:0}'

  /* order summary row */
  + '.zkb-sumhd{display:flex;align-items:center;gap:10px;width:100%;background:none;border:0;font:inherit;'
  +   'padding:0;cursor:pointer;text-align:left}'
  + '.zkb-sumhd .l{flex:1;min-width:0}'
  + '.zkb-sumhd b{font-size:14.5px;font-weight:700;color:#0A1730}'
  + '.zkb-sumhd b span{font-weight:500;color:#8A94A6;font-size:12.5px}'
  + '.zkb-sumhd .r{text-align:right;white-space:nowrap}'
  + '.zkb-sumhd .was{font-size:12.5px;color:#A6AEBD;text-decoration:line-through;margin-right:6px}'
  + '.zkb-sumhd .now{font-size:15px;font-weight:700;color:#0A1730}'
  + '.zkb-sumhd .cv{flex:0 0 auto;color:#8A94A6}'
  + '.zkb-cut{margin:10px 0 0;font-size:12.5px;font-weight:700;color:#0F7A3D;display:flex;'
  +   'align-items:center;gap:7px}'

  /* offers, one quiet line with a count on it */
  + '.zkb-oline{display:flex;align-items:center;gap:10px;width:100%;background:#fff;border:1px solid #E7EBF3;'
  +   'border-radius:14px;padding:13px 14px;margin-bottom:12px;font:inherit;font-size:13.5px;font-weight:600;'
  +   'color:#0A1730;cursor:pointer;text-align:left;transition:border-color .15s}'
  + '.zkb-oline:hover{border-color:#C6D2E8}'
  + '.zkb-oline em{position:relative;width:28px;height:28px;flex:0 0 28px;border-radius:9px;'
  +   'background:#F1F5FC;color:#2C5CC5;display:grid;place-items:center;font-style:normal}'
  + '.zkb-oline em i{position:absolute;top:-6px;right:-7px;min-width:17px;height:17px;padding:0 4px;'
  +   'border-radius:999px;background:#0F7A3D;color:#fff;font-style:normal;font-size:10px;font-weight:700;'
  +   'display:grid;place-items:center;border:2px solid #fff;line-height:1}'
  + '.zkb-oline .ar{margin-left:auto;color:#8A94A6}'

  /* headings inside a step */
  + '.zkb-t{text-align:center;margin:6px 0 3px;font-size:18px;font-weight:700;color:#0A1730;letter-spacing:-.01em}'
  + '.zkb-s{text-align:center;margin:0 0 16px;font-size:12.5px;color:#8A94A6;line-height:1.55}'

  /* phone field with the button inside it */
  + '.zkb-tel{display:flex;align-items:stretch;border:1px solid #D9DFEA;border-radius:12px;background:#fff;'
  +   'overflow:hidden;transition:border-color .15s,box-shadow .15s}'
  + '.zkb-tel.on{border-color:#2C5CC5;box-shadow:0 0 0 4px rgba(44,92,197,.12)}'
  + '.zkb-tel .cc{display:flex;align-items:center;gap:6px;padding:0 11px;font-size:14px;font-weight:600;'
  +   'color:#0A1730;background:#F7F9FC;border-right:1px solid #E7EBF3;white-space:nowrap}'
  + '.zkb-tel .cc i{width:19px;height:13px;display:block;border-radius:2px;overflow:hidden;'
  +   'background:linear-gradient(#FF9933 33%,#fff 33% 66%,#138808 66%);border:1px solid #E0E4EA}'
  + '.zkb-tel input{flex:1;min-width:0;border:0 !important;background:#fff !important;padding:14px 12px;'
  +   'font:inherit;font-size:15.5px;color:#0A1730 !important;border-radius:0 !important}'
  + '.zkb-tel input:focus{outline:0;box-shadow:none !important}'
  + '.zkb-tel button{flex:0 0 auto;border:0;background:none;color:#2C5CC5;font:inherit;font-size:11px;'
  +   'font-weight:700;letter-spacing:.1em;text-transform:uppercase;padding:0 15px;cursor:pointer;'
  +   'position:relative;white-space:nowrap}'
  + '.zkb-tel button:hover{color:#0A1730}'
  + '.zkb-tel button[disabled]{opacity:.45}'
  + '.zkb-tel button.done{color:#0F7A3D !important;display:inline-flex;align-items:center}'

  /* generic field */
  + '.zkb-f{margin-bottom:12px}'
  + '.zkb-f:last-child{margin-bottom:0}'
  + '.zkb-f label{display:block;font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;'
  +   'color:#8A94A6;margin:0 0 6px}'
  + '.zkb-r2{display:flex;gap:10px}.zkb-r2>*{flex:1;min-width:0}'
  + '.zkb-p input,.zkb-p textarea{width:100%;padding:12px 13px;font:inherit;font-size:14.5px;border-radius:11px;'
  +   'color:#0A1730 !important;background:#fff !important;border:1px solid #D9DFEA !important;'
  +   '-webkit-appearance:none;appearance:none;transition:border-color .15s,box-shadow .15s}'
  + '.zkb-p input::placeholder,.zkb-p textarea::placeholder{color:#AAB2C0 !important;opacity:1}'
  + '.zkb-p input:focus,.zkb-p textarea:focus{outline:0;border-color:#2C5CC5 !important;'
  +   'box-shadow:0 0 0 4px rgba(44,92,197,.12)}'
  + '.zkb-p textarea{min-height:70px;resize:vertical;display:block;line-height:1.5}'
  + '.zkb-otp{letter-spacing:.5em;font-weight:700;text-align:center;font-size:19px !important}'
  + '.zkb-otp.zkb-chk{opacity:.5}'
  + '.zkb-last{display:block;width:100%;margin:10px 0 0;padding:11px 14px;border:1px solid #E7EBF3;'
  +   'border-radius:11px;background:#F7F9FC;color:#0A1730;font-family:inherit;font-size:13.5px;'
  +   'font-weight:600;text-align:left;cursor:pointer;transition:border-color .18s,background .18s}'
  + '.zkb-last:hover{border-color:#C3D0E6;background:#F1F5FB}'
  + '.zkb-last b{font-weight:700;letter-spacing:.02em;margin-left:6px}'
  + '.zkb-st{position:relative}'
  + '.zkb-stl{position:absolute;left:0;right:0;top:100%;z-index:30;margin:6px 0 0;padding:6px;'
  +   'list-style:none;background:#fff;border:1px solid #E7EBF3;border-radius:12px;'
  +   'box-shadow:0 16px 34px rgba(10,23,48,.14);max-height:232px;overflow:auto;'
  +   '-webkit-overflow-scrolling:touch}'
  + '.zkb-stl li{padding:11px 12px;border-radius:8px;font-size:14.5px;color:#0A1730;cursor:pointer}'
  + '.zkb-stl li:hover,.zkb-stl li.on{background:#F1F5FB}'
  + '.zkb-stl li b{font-weight:700}'
  + '.zkb-stl .none{color:#8A97A8;cursor:default}'
  + '.zkb-stl .none:hover{background:none}'
  + '.zkb-rev{animation:zkbrev .34s cubic-bezier(.16,1,.3,1)}'
  + '@keyframes zkbrev{from{opacity:0;transform:translateY(-7px)}to{opacity:1;transform:none}}'
  + '.zkb-done{padding:34px 26px 30px;text-align:center}'
  + '.zkb-done h3{margin:22px 0 6px;font-size:1.5rem;font-weight:800;color:#0A1730;letter-spacing:-.01em}'
  + '.zkb-done .ok{margin:0;font-size:14.5px;font-weight:600;color:#1B7F4B}'
  + '.zkb-done .sm{margin:16px 0 0;font-size:12.5px;color:#8A97A8}'
  + '.zkb-tick{width:96px;height:96px;margin:0 auto;display:grid;place-items:center;border-radius:50%;'
  +   'background:#EAF7EF}'
  + '.zkb-tick svg{width:62px;height:62px;overflow:visible}'
  + '.zkb-tick circle{fill:none;stroke:#1B7F4B;stroke-width:2.5;stroke-dasharray:151;stroke-dashoffset:151;'
  +   'animation:zkbcirc .55s cubic-bezier(.65,0,.35,1) forwards}'
  + '.zkb-tick path{fill:none;stroke:#1B7F4B;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;'
  +   'stroke-dasharray:40;stroke-dashoffset:40;animation:zkbtick .34s cubic-bezier(.65,0,.35,1) .42s forwards}'
  + '@keyframes zkbcirc{to{stroke-dashoffset:0}}'
  + '@keyframes zkbtick{to{stroke-dashoffset:0}}'

  /* pay rows */
  + '.zkb-pay{background:#fff;border:1px solid #E7EBF3;border-radius:14px;padding:4px 14px}'
  + '.zkb-row{display:flex;align-items:center;gap:12px;width:100%;background:none;border:0;font:inherit;'
  +   'padding:15px 0;cursor:pointer;text-align:left;border-bottom:1px dashed #E7EBF3;transition:opacity .15s}'
  + '.zkb-row:last-child{border-bottom:0}'
  + '.zkb-row:hover{opacity:.82}'
  + '.zkb-row em{width:38px;height:38px;flex:0 0 38px;border-radius:11px;background:#F1F5FC;color:#2C5CC5;'
  +   'display:grid;place-items:center;font-style:normal}'
  + '.zkb-row .l{flex:1;min-width:0}'
  + '.zkb-row .l b{display:block;font-size:14.5px;font-weight:700;color:#0A1730}'
  + '.zkb-row .l small{display:block;font-size:12px;color:#7A8496;margin-top:3px;line-height:1.45}'
  + '.zkb-row .p{text-align:right;white-space:nowrap;font-size:14.5px;font-weight:700;color:#0A1730}'
  + '.zkb-row .p s{display:block;font-size:11.5px;font-weight:500;color:#A6AEBD}'
  + '.zkb-row .ar{flex:0 0 auto;color:#A6AEBD}'
  + '.zkb-badge{display:inline-flex;align-items:center;gap:5px;margin-top:6px;background:#E7F7EE;'
  +   'color:#0F7A3D;border-radius:20px;padding:3px 9px;font-size:10.5px;font-weight:700}'

  /* buttons */
  + '.zkb-b{position:relative;width:100%;border:0;border-radius:12px;padding:15px 18px;font:inherit;'
  +   'font-size:12.5px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;'
  +   'color:#fff;background:linear-gradient(135deg,#1E4494 0%,#0A1730 78%);display:flex;'
  +   'align-items:center;justify-content:center;gap:9px;transition:background .18s}'
  + '.zkb-b:hover{background:linear-gradient(135deg,#2C5CC5 0%,#12224A 78%)}'
  + '.zkb-b[disabled]{opacity:.5;cursor:not-allowed}'
  + '.zkb-lnk{background:none;border:0;padding:0;font:inherit;font-size:12.5px;font-weight:700;'
  +   'color:#2C5CC5;text-decoration:underline;cursor:pointer}'

  + '.zkb-msg{border:1px solid #F3CBCE;background:#FEF2F3;color:#96222A;padding:12px 13px;border-radius:11px;'
  +   'font-size:12.5px;line-height:1.55;margin:12px 0 0}'
  + '.zkb-msg small{display:block;margin-top:5px;font-size:10.5px;color:#B4676D;word-break:break-word}'
  + '.zkb-ok{display:flex;align-items:center;gap:8px;font-size:12.5px;font-weight:700;color:#0F7A3D;'
  +   'background:#E7F7EE;border:1px solid #C4EBD4;padding:11px 13px;border-radius:11px;margin-top:12px}'
  + '.zkb-hint{font-size:11.5px;color:#8A94A6;margin:10px 0 0;line-height:1.6;text-align:center}'
  + '.zkb-hide{display:none !important}'

  /* footer */
  + '.zkb-ft{padding:16px 14px 18px;border-top:1px solid #E7EBF3;background:#fff}'
  + '.zkb-tr{display:flex;justify-content:space-between;gap:6px;list-style:none;margin:0;padding:0}'
  + '.zkb-tr li{flex:1;text-align:center;font-size:9.5px;font-weight:600;color:#8A94A6;line-height:1.35}'
  + '.zkb-tr li svg{display:block;margin:0 auto 5px;color:#5A6779}'
  + '.zkb-law{display:flex;align-items:center;justify-content:center;gap:8px;margin:14px 0 0;'
  +   'font-size:11px;color:#A6AEBD}'
  + '.zkb-law a{color:#8A94A6;text-decoration:none}'
  + '.zkb-law a:hover{text-decoration:underline}'

  /* the sheet that slides up from the bottom */
  + '.zkb-sheet{position:fixed;inset:0;z-index:2147483006;display:none;background:rgba(5,11,24,.5)}'
  + '.zkb-sheet.on{display:block;animation:zkb-fade .16s ease both}'
  + '.zkb-sh{position:absolute;left:50%;bottom:0;transform:translateX(-50%);width:100%;max-width:470px;'
  +   'background:#F6F8FB;border-radius:20px 20px 0 0;max-height:82vh;display:flex;flex-direction:column;'
  +   'animation:zkb-up .3s cubic-bezier(.16,1,.3,1) both;box-shadow:0 -18px 50px rgba(2,6,16,.4)}'
  + '@keyframes zkb-up{from{transform:translate(-50%,100%)}to{transform:translate(-50%,0)}}'
  + '.zkb-shh{display:flex;align-items:center;gap:10px;padding:16px 16px 12px;border-bottom:1px solid #E7EBF3;'
  +   'background:#fff;border-radius:20px 20px 0 0}'
  + '.zkb-shh b{flex:1;font-size:15px;font-weight:700;color:#0A1730}'
  + '.zkb-shh b span{font-weight:500;color:#8A94A6;font-size:12.5px}'
  + '.zkb-shx{width:30px;height:30px;flex:0 0 30px;border:1px solid #E7EBF3;background:#fff;color:#5A6779;'
  +   'border-radius:9px;cursor:pointer;display:grid;place-items:center;padding:0;font-family:inherit}'
  + '.zkb-shx:hover{background:#F1F4F9;color:#0A1730}'
  + '.zkb-shb{padding:14px;overflow-y:auto;-webkit-overflow-scrolling:touch}'

  /* an item line inside the sheet */
  + '.zkb-li{display:flex;gap:11px;align-items:center;background:#fff;border:1px solid #E7EBF3;'
  +   'border-radius:12px;padding:10px;margin-bottom:9px}'
  + '.zkb-li img{width:46px;height:46px;flex:0 0 46px;object-fit:cover;border-radius:9px;background:#F2F5FA;'
  +   'border:1px solid #EAEEF5}'
  + '.zkb-li .t{flex:1;min-width:0;font-size:12.5px;line-height:1.4;color:#0A1730;font-weight:500}'
  + '.zkb-li .q{font-size:11.5px;color:#8A94A6;margin-top:2px}'
  + '.zkb-li .m{font-size:13px;font-weight:700;color:#0A1730;white-space:nowrap}'
  + '.zkb-bill{background:#fff;border:1px solid #E7EBF3;border-radius:12px;padding:13px;margin-top:12px}'
  + '.zkb-bill h4{margin:0 0 11px;font-size:10.5px;font-weight:700;letter-spacing:.14em;'
  +   'text-transform:uppercase;color:#8A94A6}'
  + '.zkb-br{display:flex;justify-content:space-between;gap:12px;font-size:12.5px;color:#5A6779;margin-bottom:8px}'
  + '.zkb-br b{color:#0A1730;font-weight:600}'
  + '.zkb-br.g,.zkb-br.g b{color:#0F7A3D}'
  + '.zkb-br.tot{margin:10px 0 0;padding-top:10px;border-top:1px solid #EEF1F6;font-size:14.5px;'
  +   'color:#0A1730;font-weight:700}'
  + '.zkb-br.tot b{font-size:16px}'

  /* an offer inside the sheet */
  + '.zkb-of{display:flex;align-items:center;gap:11px;background:#fff;border:1px solid #E7EBF3;'
  +   'border-radius:12px;padding:12px;margin-bottom:9px}'
  + '.zkb-of.on{border-color:#0F7A3D;background:#F6FDF9}'
  + '.zkb-of .tx{flex:1;min-width:0}'
  + '.zkb-of b{display:block;font-size:13px;font-weight:700;color:#0A1730;line-height:1.35}'
  + '.zkb-of small{display:block;font-size:11.5px;color:#7A8496;margin-top:2px}'
  + '.zkb-of code{display:inline-block;margin-top:7px;font-family:inherit;font-size:11px;font-weight:700;'
  +   'letter-spacing:.14em;color:#0A1730;background:#EEF3FC;border-radius:6px;padding:4px 9px}'
  + '.zkb-ap{flex:0 0 auto;border:1px solid #0A1730;background:#0A1730;color:#fff;border-radius:9px;'
  +   'padding:9px 14px;font:inherit;font-size:10px;font-weight:700;letter-spacing:.11em;'
  +   'text-transform:uppercase;cursor:pointer;position:relative}'
  + '.zkb-ap:hover{background:#1E4494;border-color:#1E4494}'
  + '.zkb-ap.done{background:#0F7A3D;border-color:#0F7A3D}'
  + '.zkb-ap[disabled]{opacity:.55;cursor:not-allowed}'

  /* The little celebration when a code lands. It is a card, not a sheet:
     the popup behind it already dims the page, and a second dark layer on
     top of that blacked out the whole screen. Nothing here takes a click
     except the card itself, so the order underneath stays readable. */
  + '.zkb-cel{position:fixed;inset:0;z-index:2147483007;display:grid;place-items:center;padding:20px;'
  +   'pointer-events:none;background:none}'
  + '.zkb-cc{pointer-events:auto;background:#fff;border-radius:16px;padding:22px 26px 14px;text-align:center;'
  +   'max-width:320px;width:100%;box-shadow:0 24px 60px rgba(2,6,16,.4);'
  +   'animation:zkb-pop .46s cubic-bezier(.16,1,.3,1) .14s both}'
  /* a beat after the popup has settled, then it swells in and eases back -
     landing on the same frame as everything else read as no animation at all */
  + '@keyframes zkb-pop{0%{opacity:0;transform:scale(.72)}'
  +   '62%{opacity:1;transform:scale(1.04)}100%{opacity:1;transform:scale(1)}}'
  /* themes love to make every svg a block; this one is centred either way */
  + '.zkb-cc>svg{display:block;margin:0 auto}'
  + '.zkb-cc h4{margin:14px 0 6px;font-size:18px;font-weight:700;color:#0A1730}'
  + '.zkb-cc p{margin:0;font-size:13.5px;color:#5A6779;line-height:1.55}'
  + '.zkb-cc button{margin-top:18px;width:100%;background:none;border:0;border-top:1px solid #EEF1F6;'
  +   'padding:14px 0 4px;font:inherit;font-size:14.5px;font-weight:700;color:#0F7A3D;cursor:pointer}'
  + '.zkb-conf{position:fixed;inset:0;z-index:2147483008;pointer-events:none;overflow:hidden}'
  + '.zkb-conf i{position:absolute;top:-16px;width:9px;height:15px;border-radius:1px;opacity:.95;'
  +   'animation:zkb-fall linear forwards}'
  + '@keyframes zkb-fall{to{transform:translateY(108vh) rotate(760deg)}}'

  /* waiting */
  + '.zkb-wait{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:22px;'
  +   'padding:74px 24px;min-height:300px;background:#fff}'
  + '.zkb-ring{position:relative;width:118px;height:118px;display:grid;place-items:center}'
  + '.zkb-ring::before,.zkb-ring::after{content:"";position:absolute;inset:0;border-radius:50%;'
  +   'border:2.5px solid transparent}'
  + '.zkb-ring::before{border-color:#E7EBF3}'
  + '.zkb-ring::after{border-top-color:#2C5CC5;border-right-color:#2C5CC5;'
  +   'animation:zkb-a 1.05s cubic-bezier(.62,.06,.38,.96) infinite}'
  + '.zkb-ring i{position:absolute;inset:15px;border-radius:50%;border:1.5px solid transparent;'
  +   'border-bottom-color:#9FB6E8;border-left-color:#9FB6E8;animation:zkb-b .74s linear infinite}'
  + '.zkb-ring img{position:relative;width:78px;height:78px;object-fit:contain;display:block}'
  + '.zkb-wait p{margin:0;font-size:14px;font-weight:600;color:#5A6779;text-align:center}'

  /* the two counter-turning arcs, same as the rest of the site */
  + '.zkb-busy{color:transparent !important;pointer-events:none}'
  + '.zkb-busy::after,.zkb-busy::before{content:"";position:absolute;top:50%;left:50%;border-radius:50%;'
  +   'border-style:solid;border-color:currentColor}'
  + '.zkb-busy::after{width:17px;height:17px;margin:-8.5px 0 0 -8.5px;border-width:2px;'
  +   'border-right-color:transparent;border-bottom-color:transparent;'
  +   'animation:zkb-a .92s cubic-bezier(.62,.06,.38,.96) infinite}'
  + '.zkb-busy::before{width:8px;height:8px;margin:-4px 0 0 -4px;border-width:1.5px;opacity:.5;'
  +   'border-left-color:transparent;border-top-color:transparent;animation:zkb-b .58s linear infinite}'
  + '.zkb-b.zkb-busy::after,.zkb-ap.zkb-busy::after'
  +   '{border-color:#fff;border-right-color:transparent;border-bottom-color:transparent}'
  + '.zkb-b.zkb-busy::before,.zkb-ap.zkb-busy::before'
  +   '{border-color:#fff;border-left-color:transparent;border-top-color:transparent}'
  + '.zkb-tel button.zkb-busy::after{border-color:#2C5CC5;'
  +   'border-right-color:transparent;border-bottom-color:transparent}'
  + '.zkb-tel button.zkb-busy::before{border-color:#2C5CC5;'
  +   'border-left-color:transparent;border-top-color:transparent}'
  + '@keyframes zkb-a{to{transform:rotate(360deg)}}'
  + '@keyframes zkb-b{to{transform:rotate(-360deg)}}'

  + '@media(prefers-reduced-motion:reduce){'
  +   '.zkb-p,.zkb-body,.zkb-sh,.zkb-ov.on{animation:none}'
  +   '.zkb-ring::after,.zkb-ring i{animation-duration:2.4s}'
  +   '.zkb-nx u{transition:none}'
  + '}'
  + '@media(max-width:520px){'
  +   '.zkb-ov{padding:0}'
  +   '.zkb-p{border-radius:0;min-height:100vh;max-width:none}'
  +   '.zkb-sh{max-width:none}'
  + '}';

  var styled = false;
  function styles() {
    if (styled) return;
    styled = true;
    var s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ---------------------------------------------------------------- */
  /*  helpers                                                          */
  /* ---------------------------------------------------------------- */

  function esc(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function money(n) {
    var v = Math.round(Number(n) * 100) / 100;
    return '₹' + (v % 1 === 0 ? v.toLocaleString('en-IN')
      : v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }
  function digits(s) { return String(s || '').replace(/\D/g, ''); }
  function busy(b, on) { if (b) { b.classList.toggle('zkb-busy', !!on); b.disabled = !!on; } }

  function ico(paths, size, w) {
    return '<svg width="' + (size || 16) + '" height="' + (size || 16) + '" viewBox="0 0 24 24" fill="none" '
      + 'stroke="currentColor" stroke-width="' + (w || 2) + '" stroke-linecap="round" '
      + 'stroke-linejoin="round">' + paths + '</svg>';
  }
  function chev(s) { return ico('<path d="M9 5l7 7-7 7"/>', s || 16, 2.2); }
  function back() { return ico('<path d="M19 12H5M11 18l-6-6 6-6"/>', 17, 2.2); }
  function cross(s) { return ico('<path d="M18 6L6 18M6 6l12 12"/>', s || 16, 2.2); }
  function lock(s) { return ico('<rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>', s || 15); }
  function tick(s) { return ico('<path d="M4 12.5l5 5L20 6.5"/>', s || 13, 2.5); }
  function bolt() { return ico('<path d="M13 2L4 14h6l-1 8 9-12h-6z"/>', 13, 1.9); }
  function truck() { return ico('<rect x="1" y="6" width="14" height="11" rx="1.5"/><path d="M15 9h4l3 3.5V17h-7z"/><circle cx="6" cy="19" r="1.7"/><circle cx="18" cy="19" r="1.7"/>', 18, 1.8); }
  function shield() { return ico('<path d="M12 2.5l8 3.2v5.6c0 5-3.4 9.2-8 10.2-4.6-1-8-5.2-8-10.2V5.7z"/><path d="M9 12l2.2 2.2L15.5 10"/>', 18, 1.8); }
  function card() { return ico('<rect x="2" y="5" width="20" height="14" rx="2.5"/><path d="M2 10h20M6 15h4"/>', 18, 1.8); }
  function cash() { return ico('<rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="3"/><path d="M6 12h.01M18 12h.01"/>', 18, 1.8); }
  function gift(s) { return ico('<rect x="3" y="8" width="18" height="12" rx="2"/><path d="M12 8v12M3 12h18"/><path d="M12 8S9.6 3.4 7.7 4.5 9.6 8 12 8zM12 8s2.4-4.6 4.3-3.5S14.4 8 12 8z"/>', s || 16, 1.9); }

  /** If the picture ever fails to load, the name takes its place - a
   *  checkout with an empty header looks broken. */
  function logoTag() {
    return '<img class="zkb-lg" src="' + LOGO + '" alt="Zakdor">';
  }

  function guardLogo() {
    var imgs = ov.querySelectorAll('.zkb-lg');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].addEventListener('error', function () {
        var b = document.createElement('b');
        b.className = 'zkb-wm';
        b.textContent = 'ZAKDOR';
        if (this.parentNode) this.parentNode.replaceChild(b, this);
      }, { once: true });
    }
  }

  /** The verified seal - a scalloped badge with a tick, in whatever two
   *  colours suit the background it sits on. */
  function seal(size, fill, ink) {
    var s = size || 18;
    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" aria-hidden="true">'
      + '<path fill="' + (fill || '#16A34A') + '" d="M12 1.6l2.06 1.63 2.62-.24.87 2.49 2.49.87-.24 2.62L21.43 11'
      + 'l-1.63 2.06.24 2.62-2.49.87-.87 2.49-2.62-.24L12 20.43l-2.06-1.63-2.62.24-.87-2.49-2.49-.87.24-2.62'
      + 'L2.57 11l1.63-2.06-.24-2.62 2.49-.87.87-2.49 2.62.24z"/>'
      + '<path d="M8.4 11.6l2.3 2.3 4.6-4.8" fill="none" stroke="' + (ink || '#fff') + '" stroke-width="2" '
      + 'stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  /** The same badge as the seal, with a per-cent sign in place of the tick.
   *  A tick says "done"; on a saving what the eye wants is the discount
   *  itself, which is what this says. */
  function cut(size) {
    var s = size || 18;
    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" aria-hidden="true">'
      + '<path fill="#16A34A" d="M12 1.6l2.06 1.63 2.62-.24.87 2.49 2.49.87-.24 2.62L21.43 11'
      + 'l-1.63 2.06.24 2.62-2.49.87-.87 2.49-2.62-.24L12 20.43l-2.06-1.63-2.62.24-.87-2.49-2.49-.87.24-2.62'
      + 'L2.57 11l1.63-2.06-.24-2.62 2.49-.87.87-2.49 2.62.24z"/>'
      + '<g fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round">'
      + '<path d="M15.1 8.9l-6.2 6.2"/><circle cx="9.3" cy="9.3" r="1.5"/>'
      + '<circle cx="14.7" cy="14.7" r="1.5"/></g></svg>';
  }

  /* ---------------------------------------------------------------- */
  /*  shell                                                            */
  /* ---------------------------------------------------------------- */

  var ov = null, sheet = null, D = null, STEP = 1, PAY = 'prepaid', VERIFIED = false, PHONE = '';
  /** Held between step 2 and step 3, so going back does not lose it. */
  var ADDR = null;

  function shell() {
    styles();
    ov = document.createElement('div');
    ov.className = 'zkb-ov';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Complete your order');
    document.body.appendChild(ov);

    sheet = document.createElement('div');
    sheet.className = 'zkb-sheet';
    document.body.appendChild(sheet);

    ov.addEventListener('click', function (e) {
      if (e.target === ov) { close(); return; }
      if (!e.target.closest) return;
      if (e.target.closest('[data-zkb-close]')) { close(); return; }
      if (e.target.closest('[data-zkb-back]')) { goBack(); return; }
      if (e.target.closest('[data-zkb-items]')) { openItems(); return; }
      if (e.target.closest('[data-zkb-offers]')) { openOffers(); return; }
    });

    sheet.addEventListener('click', function (e) {
      if (e.target === sheet) { closeSheet(); return; }
      if (!e.target.closest) return;
      if (e.target.closest('[data-zkb-sheetclose]')) { closeSheet(); return; }
      var ap = e.target.closest('.zkb-ap');
      if (ap) apply(ap);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (sheet && sheet.classList.contains('on')) { closeSheet(); return; }
      if (ov && ov.classList.contains('on')) close();
    });
  }

  /* The theme's cart drawer is a <dialog>. On a wide screen it holds a
     focus trap - any focus landing outside it is thrown straight back in -
     and on a narrow one it is modal, which makes the rest of the page
     inert. Either way a popup opened over it cannot be typed into: the
     number field took the click and lost it in the same instant. So the
     drawer is closed first; its own close() drops the trap at once and
     slides it away. */
  function shutDrawers() {
    var ds = document.querySelectorAll('theme-drawer');
    for (var i = 0; i < ds.length; i++) {
      var d = ds[i], dlg = d.querySelector('dialog');
      try {
        if (d.hasAttribute('open') && typeof d.close === 'function') d.close();
        else if (dlg && dlg.open) dlg.close();
      } catch (e) {}
    }
  }

  function open() {
    if (!ov) shell();
    shutDrawers();
    ov.classList.add('on');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  function close() {
    if (!ov) return;
    if (NXT) { clearInterval(NXT); NXT = null; }
    closeSheet();
    ov.classList.remove('on');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }
  function goBack() {
    if (STEP === 3) { STEP = 2; render(); return; }
    if (STEP === 2) { STEP = 1; render(); return; }
    close();
  }
  function closeSheet() { if (sheet) { sheet.classList.remove('on'); sheet.innerHTML = ''; } }

  function openSheet(title, body) {
    sheet.innerHTML = '<div class="zkb-sh"><div class="zkb-shh"><b>' + title + '</b>'
      + '<button type="button" class="zkb-shx" data-zkb-sheetclose aria-label="Close">' + cross(15) + '</button>'
      + '</div><div class="zkb-shb">' + body + '</div></div>';
    sheet.classList.add('on');
  }

  /* ---------------------------------------------------------------- */
  /*  offers, read straight from the theme                             */
  /* ---------------------------------------------------------------- */

  function offers() {
    try {
      var el = document.getElementById('axOffersData');
      if (!el) return [];
      var d = JSON.parse(el.textContent || '{}');
      var out = [];
      for (var i = 0; i < (d.items || []).length; i++) {
        if (d.items[i] && d.items[i].code) out.push(d.items[i]);
      }
      return out;
    } catch (e) { return []; }
  }

  function openOffers() {
    var list = offers(), body = '';
    for (var i = 0; i < list.length; i++) {
      var o = list[i];
      var on = D.discountCode && String(D.discountCode).toUpperCase() === String(o.code).toUpperCase();
      body += '<div class="zkb-of' + (on ? ' on' : '') + '"><div class="tx"><b>' + esc(o.title || o.code) + '</b>'
        + (o.note ? '<small>' + esc(o.note) + '</small>' : '')
        + '<code>' + esc(o.code) + '</code></div>'
        + '<button type="button" class="zkb-ap' + (on ? ' done' : '') + '" data-code="' + esc(o.code) + '"'
        + (on ? ' disabled' : '') + '>' + (on ? 'Applied' : 'Apply') + '</button></div>';
    }
    body += '<p class="zkb-hint">One code per order. Applying a code replaces the one before it.</p>';
    openSheet('Offers &amp; gift cards', body);
  }

  function openItems() {
    var body = '';
    for (var i = 0; i < D.lines.length; i++) {
      var l = D.lines[i];
      body += '<div class="zkb-li">'
        + (l.image ? '<img src="' + esc(l.image) + '" alt="">' : '')
        + '<div class="t">' + esc(l.title) + '<div class="q">Qty ' + l.quantity + '</div></div>'
        + '<div class="m">' + money(l.price * l.quantity) + '</div></div>';
    }
    body += '<div class="zkb-bill"><h4>Bill summary</h4>'
      + '<div class="zkb-br"><span>Subtotal</span><b>' + money(D.subtotal) + '</b></div>'
      + (D.discountAmount > 0
        ? '<div class="zkb-br g"><span>Discount'
          + (D.discountCode ? ' (' + esc(D.discountCode) + ')' : '') + '</span><b>&minus;'
          + money(D.discountAmount) + '</b></div>'
        : '')
      + '<div class="zkb-br"><span>Shipping</span><b>Free</b></div>'
      + '<div class="zkb-br tot"><span>Total amount</span><b>' + money(D.total) + '</b></div></div>';
    openSheet('Order summary <span>(' + D.count + ' item' + (D.count === 1 ? '' : 's') + ')</span>', body);
  }

  /* Shopify keeps the cart's discount on the session, so asking for
     /discount/<CODE> is all it takes - then the cart is read again and the
     whole popup is redrawn with the new figures. */
  function apply(btn) {
    if (MODE !== 'cart') return;
    var code = btn.getAttribute('data-code') || '';
    busy(btn, true);
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { return fromCart(); })
      .then(function (dd) {
        busy(btn, false);
        if (!dd) return;
        var up = code.toUpperCase();
        var worked = dd.discountAmount > 0 && ((dd.discountCode && String(dd.discountCode).toUpperCase() === up)
          || (dd.codes && dd.codes.indexOf(up) >= 0));
        if (worked) dd.discountCode = code;
        D = dd;
        if (worked) {
          closeSheet();
          render();
          celebrate(dd.discountCode, dd.discountAmount);
        } else {
          btn.textContent = 'Not valid';
          setTimeout(function () { btn.textContent = 'Apply'; }, 1900);
        }
      })
      .catch(function () {
        busy(btn, false);
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = 'Apply'; }, 1900);
      });
  }

  /* A code landing is the one moment in a checkout worth celebrating.
     Paper falls for two seconds, then it is gone on its own. */
  var CONF = ['#2C5CC5', '#16A34A', '#FFC94A', '#F0577D', '#7C5CFF', '#38BDF8'];

  /* Every trip through the popup with a code on the cart is worth saying
     out loud - the shopper sees what they are saving right before they pay,
     every time, not just the first time. */
  function celebrateOnce(code, amount) {
    if (!code || !(amount > 0)) return;
    celebrate(code, amount);
  }

  function celebrate(code, amount) {
    var paper = document.createElement('div');
    paper.className = 'zkb-conf';
    var bits = '';
    for (var i = 0; i < 46; i++) {
      bits += '<i style="left:' + (Math.random() * 100).toFixed(2) + '%;'
        + 'background:' + CONF[i % CONF.length] + ';'
        + 'animation-duration:' + (1.8 + Math.random() * 1.4).toFixed(2) + 's;'
        + 'animation-delay:' + (Math.random() * .5).toFixed(2) + 's"></i>';
    }
    paper.innerHTML = bits;
    document.body.appendChild(paper);
    setTimeout(function () { if (paper.parentNode) paper.parentNode.removeChild(paper); }, 3400);

    var box = document.createElement('div');
    box.className = 'zkb-cel';
    box.innerHTML = '<div class="zkb-cc">' + cut(46)
      + '<h4>"' + esc(code) + '" applied</h4>'
      + '<p>You just saved ' + money(amount) + ' on this order!</p>'
      + '<button type="button">Woohoo! Thanks</button></div>';
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.tagName === 'BUTTON') {
        if (box.parentNode) box.parentNode.removeChild(box);
      }
    });
    var was = document.querySelector('.zkb-cel');
    if (was && was.parentNode) was.parentNode.removeChild(was);
    document.body.appendChild(box);
  }

  /* ---------------------------------------------------------------- */
  /*  the waiting screen                                               */
  /* ---------------------------------------------------------------- */

  function waitCard(text) {
    return '<div class="zkb-p">'
      + '<div class="zkb-hd">' + logoTag()
      + '<span class="sl">' + seal(19) + '</span></div>'
      + '<div class="zkb-wait"><div class="zkb-ring"><i></i><img src="' + MARK + '" alt=""></div>'
      + '<p>' + esc(text) + '</p></div>'
      + footer() + '</div>';
  }

  /* An order placed is the one moment in the whole flow that deserves a
     sound. Three rising notes, built here rather than downloaded, so it
     costs nothing to carry and cannot fail to load. */
  function chime() {
    try {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;
      var a = new AC();
      var notes = [[880, 0], [1174.66, 0.10], [1567.98, 0.20]];
      for (var i = 0; i < notes.length; i++) {
        var o = a.createOscillator(), g = a.createGain();
        o.type = 'sine';
        o.frequency.value = notes[i][0];
        o.connect(g); g.connect(a.destination);
        var t = a.currentTime + notes[i][1];
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.15, t + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.40);
        o.start(t); o.stop(t + 0.44);
      }
      setTimeout(function () { try { a.close(); } catch (e) {} }, 1400);
    } catch (e) {}
  }

  function doneCard(name) {
    return '<div class="zkb-p">'
      + '<div class="zkb-hd">' + logoTag()
      + '<span class="sl">' + seal(19) + '</span></div>'
      + '<div class="zkb-done">'
      + '<div class="zkb-tick"><svg viewBox="0 0 52 52" aria-hidden="true">'
      +   '<circle cx="26" cy="26" r="24"/><path d="M15 27l8 8 15-16"/></svg></div>'
      + '<h3>Thank you!</h3>'
      + '<p class="ok">Order ' + esc(name) + ' is confirmed</p>'
      + '<p class="sm">Opening your order&hellip;</p>'
      + '</div>' + footer() + '</div>';
  }

  /* ---------------------------------------------------------------- */
  /*  the card, redrawn per step                                       */
  /* ---------------------------------------------------------------- */

  function header() {
    return '<div class="zkb-hd">'
      + '<button type="button" class="nav bk' + (STEP === 1 ? ' off' : '') + '" data-zkb-back '
      + 'aria-label="Back">' + back() + '</button>'
      + logoTag()
      + '<span class="sl" title="Verified store">' + seal(19) + '</span>'
      + '<button type="button" class="nav cl" data-zkb-close aria-label="Close">' + cross(16) + '</button></div>';
  }

  function summaryRow() {
    return '<div class="zkb-card">'
      + '<button type="button" class="zkb-sumhd" data-zkb-items>'
      + '<div class="l"><b>Order summary <span>(' + D.count + ' item' + (D.count === 1 ? '' : 's') + ')</span></b></div>'
      + '<div class="r">'
      + (D.discountAmount > 0 ? '<span class="was">' + money(D.subtotal) + '</span>' : '')
      + '<span class="now">' + money(D.total) + '</span></div>'
      + '<span class="cv">' + chev(15) + '</span></button>'
      + (D.discountAmount > 0
        ? '<div class="zkb-cut">' + cut(15) + esc(D.discountCode || 'Discount')
          + ' applied &middot; you save ' + money(D.discountAmount) + '</div>'
        : '')
      + '</div>';
  }

  /* every offer, one after another, on the black band under the header */
  function nextMsgs() {
    var out = [];
    if (NEXT_OFFER) out.push(NEXT_OFFER);
    var l = offers();
    for (var i = 0; i < l.length; i++) {
      var o = l[i];
      out.push((o.short || o.title || o.code) + ' — use code ' + o.code);
    }
    return out;
  }

  function nextStrip() {
    var m = nextMsgs();
    if (!m.length) return '';
    var s = '<div class="zkb-next">' + bolt() + '<span class="zkb-nx"><u>';
    for (var i = 0; i < m.length; i++) s += '<b>' + esc(m[i]) + '</b>';
    return s + '</u></span></div>';
  }

  var NXT = null;
  function slide() {
    if (NXT) { clearInterval(NXT); NXT = null; }
    var u = ov && ov.querySelector('.zkb-nx u');
    if (!u || u.children.length < 2) return;
    var i = 0, n = u.children.length;
    NXT = setInterval(function () {
      if (!u.isConnected) { clearInterval(NXT); NXT = null; return; }
      i = (i + 1) % n;
      u.style.transform = 'translateY(-' + (i * 17) + 'px)';
    }, 3400);
  }

  function offerLine() {
    var n = offers().length;
    if (!n) return '';
    return '<button type="button" class="zkb-oline" data-zkb-offers>'
      + '<em>' + gift(15) + '<i>' + n + '</i></em>View offers &amp; gift cards'
      + '<span class="ar">' + chev(15) + '</span></button>';
  }

  function footer() {
    return '<div class="zkb-ft"><ul class="zkb-tr">'
      + '<li>' + lock(18) + 'Encrypted<br>checkout</li>'
      + '<li>' + card() + 'Secure<br>payments</li>'
      + '<li>' + truck() + 'Assured<br>delivery</li>'
      + '<li>' + shield() + 'Verified<br>seller</li>'
      + '</ul><div class="zkb-law"><a href="/policies/terms-of-service">T&amp;C</a><span>|</span>'
      + '<a href="/policies/privacy-policy">Privacy Policy</a></div></div>';
  }

  /* The number this browser used last time. Typing ten digits again on
     every visit is the sort of small tax that loses orders. */
  function saved() {
    try { return (window.localStorage.getItem('zkbPhone') || '').replace(/\D/g, ''); }
    catch (e) { return ''; }
  }
  function remember(p) {
    try { window.localStorage.setItem('zkbPhone', String(p || '').replace(/\D/g, '')); }
    catch (e) {}
  }
  function pretty(p) {
    var d = String(p || '').replace(/\D/g, '').slice(-10);
    return d.length === 10 ? '+91 ' + d.slice(0, 5) + ' ' + d.slice(5) : '+91 ' + d;
  }

  function savedLine() {
    var d = saved();
    if (!d || d.length !== 10 || d === digits(PHONE)) return '';
    return '<button type="button" id="zkbLast" class="zkb-last">Continue<b>'
      + esc(pretty(d)) + '</b></button>';
  }

  function stepPhone() {
    return '<div class="zkb-card">'
      + '<div class="zkb-t">Enter mobile number</div>'
      + '<p class="zkb-s">We send a short code so the parcel reaches the right person.</p>'
      + '<div class="zkb-tel" id="zkbTel"><span class="cc"><i></i>+91</span>'
      + '<input id="zkbPh" inputmode="numeric" maxlength="10" placeholder="10-digit number" autocomplete="tel" value="'
      + esc(PHONE) + '">'
      + '<button type="button" id="zkbSend">Send</button></div>'
      + savedLine()
      + '<div id="zkbOtp" class="zkb-hide" style="margin-top:14px">'
      + '<input id="zkbC" class="zkb-otp" inputmode="numeric" maxlength="6" placeholder="000000" '
      +   'autocomplete="one-time-code">'
      + '<p id="zkbChk" class="zkb-hint zkb-hide">Checking…</p>'
      + '<div style="margin-top:11px;text-align:center">'
      + '<button type="button" id="zkbResend" class="zkb-lnk">Send again</button></div></div>'
      + '<div id="zkbOk" class="zkb-ok zkb-hide">' + seal(16) + 'Number confirmed</div>'
      + '<div id="zkbErr" class="zkb-msg zkb-hide"></div>'
      + '<button type="button" id="zkbNext" class="zkb-b" style="margin-top:14px">Continue</button>'
      + '</div>';
  }

  function stepPay() {
    /* Paying online saves Rs 30 on a single item and Rs 20 on each item from
       two up, on top of any code already applied - PREPAID30 and PREPAID35 are
       set up in Shopify to stack with the order codes. */
    var off = D.count === 1 ? 30 : D.count * 20;
    var prepaid = Math.max(0, D.total - off);
    var to = ADDR
      ? '<p class="zkb-hint" style="text-align:left;margin:0 0 12px">Delivering to '
        + esc(ADDR.address1) + ', ' + esc(ADDR.city) + ' ' + esc(ADDR.zip) + '</p>'
      : '';
    return to + '<div class="zkb-pay">'
      + '<button type="button" class="zkb-row" data-pay="prepaid">'
      + '<em>' + card() + '</em><div class="l"><b>Pay online</b>'
      + '<small>UPI, card or net banking</small>'
      + (off > 0 ? '<span class="zkb-badge">' + seal(13) + 'Save ' + money(off) + '</span>' : '')
      + '</div><div class="p">'
      + (off > 0 ? '<s>' + money(D.total) + '</s>' : '') + money(prepaid) + '</div>'
      + '<span class="ar">' + chev(16) + '</span></button>'
      + '<button type="button" class="zkb-row" data-pay="cod">'
      + '<em>' + cash() + '</em><div class="l"><b>Cash on Delivery</b>'
      + '<small>Pay the delivery agent at your door</small></div>'
      + '<div class="p">' + money(D.total) + '</div>'
      + '<span class="ar">' + chev(16) + '</span></button>'
      + '</div>'
      + '<div id="zkbErr" class="zkb-msg zkb-hide"></div>';
  }

  /* Shopify stores an Indian state as its two-letter code, so that is what
     the value carries and the name is only what the shopper reads. */
  var STATES = [
    ['AN', 'Andaman and Nicobar Islands'], ['AP', 'Andhra Pradesh'], ['AR', 'Arunachal Pradesh'],
    ['AS', 'Assam'], ['BR', 'Bihar'], ['CH', 'Chandigarh'], ['CT', 'Chhattisgarh'],
    ['DH', 'Dadra and Nagar Haveli and Daman and Diu'], ['DL', 'Delhi'], ['GA', 'Goa'],
    ['GJ', 'Gujarat'], ['HR', 'Haryana'], ['HP', 'Himachal Pradesh'], ['JK', 'Jammu and Kashmir'],
    ['JH', 'Jharkhand'], ['KA', 'Karnataka'], ['KL', 'Kerala'], ['LA', 'Ladakh'],
    ['LD', 'Lakshadweep'], ['MP', 'Madhya Pradesh'], ['MH', 'Maharashtra'], ['MN', 'Manipur'],
    ['ML', 'Meghalaya'], ['MZ', 'Mizoram'], ['NL', 'Nagaland'], ['OR', 'Odisha'],
    ['PY', 'Puducherry'], ['PB', 'Punjab'], ['RJ', 'Rajasthan'], ['SK', 'Sikkim'],
    ['TN', 'Tamil Nadu'], ['TG', 'Telangana'], ['TR', 'Tripura'], ['UP', 'Uttar Pradesh'],
    ['UT', 'Uttarakhand'], ['WB', 'West Bengal']
  ];
  function stateName(code) {
    for (var i = 0; i < STATES.length; i++) if (STATES[i][0] === code) return STATES[i][1];
    return '';
  }

  function stepAddress() {
    return '<div class="zkb-card">'
      + '<div class="zkb-t">Delivery details</div>'
      + '<p class="zkb-s">Where should we send it?</p>'
      + '<form id="zkbF" autocomplete="on" novalidate>'
      + '<div class="zkb-r2">'
      + '<div class="zkb-f"><label for="zkbFn">First name</label>'
      + '<input id="zkbFn" name="firstName" placeholder="Rahul" autocomplete="given-name"></div>'
      + '<div class="zkb-f"><label for="zkbLn">Last name</label>'
      + '<input id="zkbLn" name="lastName" placeholder="Kumar" autocomplete="family-name"></div></div>'
      + '<div class="zkb-f"><label for="zkbA1">Full address</label>'
      + '<textarea id="zkbA1" name="address1" placeholder="House / street / area / landmark" autocomplete="street-address"></textarea></div>'
      + '<div class="zkb-r2">'
      + '<div class="zkb-f"><label for="zkbCt">City</label>'
      + '<input id="zkbCt" name="city" placeholder="City" autocomplete="address-level2"></div>'
      + '<div class="zkb-f"><label for="zkbZp">PIN code</label>'
      + '<input id="zkbZp" name="zip" inputmode="numeric" maxlength="6" placeholder="6 digits" autocomplete="postal-code"></div></div>'
      + '<div class="zkb-f zkb-st"><label for="zkbSt">State</label>'
      + '<input id="zkbSt" autocomplete="address-level1" '
      +   'role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="zkbStL">'
      + '<input type="hidden" id="zkbStC" name="province">'
      + '<ul id="zkbStL" class="zkb-stl zkb-hide" role="listbox"></ul></div>'
      + '<div class="zkb-f"><label for="zkbEm">Email (optional)</label>'
      + '<input id="zkbEm" name="email" type="email" placeholder="you@example.com" autocomplete="email"></div>'
      + '<div id="zkbErr" class="zkb-msg zkb-hide"></div>'
      + '<button type="submit" id="zkbGo" class="zkb-b" style="margin-top:14px">'
      + seal(17) + '<span>Continue</span></button>'
      + '</form></div>';
  }

  function render() {
    var mid = STEP === 1 ? stepPhone() : STEP === 2 ? stepAddress() : stepPay();
    ov.innerHTML = '<div class="zkb-p">'
      + header()
      + nextStrip()
      + (D.discountAmount > 0
        ? '<div class="zkb-saved">' + cut(15) + 'Yay! You have saved ' + money(D.discountAmount) + ' so far</div>'
        : '')
      + '<div class="zkb-body">' + summaryRow() + offerLine() + mid + '</div>'
      + footer() + '</div>';
    guardLogo();
    wire();
    slide();
  }

  /* ---------------------------------------------------------------- */
  /*  behaviour                                                        */
  /* ---------------------------------------------------------------- */

  function wire() {
    var err = ov.querySelector('#zkbErr');
    function fail(m, detail) {
      if (!err) return;
      err.innerHTML = esc(m) + (detail ? '<small>' + esc(detail) + '</small>' : '');
      err.classList.remove('zkb-hide');
    }
    function clear() { if (err) err.classList.add('zkb-hide'); }

    function post(body) {
      return fetch('/apps/track/otp', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    if (STEP === 1) {
      var tel = ov.querySelector('#zkbTel'), ph = ov.querySelector('#zkbPh'),
          send = ov.querySelector('#zkbSend'), otpBox = ov.querySelector('#zkbOtp'),
          code = ov.querySelector('#zkbC'), checkTip = ov.querySelector('#zkbChk'),
          resend = ov.querySelector('#zkbResend'), okBox = ov.querySelector('#zkbOk'),
          next = ov.querySelector('#zkbNext');

      ph.addEventListener('focus', function () { tel.classList.add('on'); });
      ph.addEventListener('blur', function () { tel.classList.remove('on'); });
      ph.addEventListener('input', function () { PHONE = digits(ph.value); });

      if (VERIFIED) {
        okBox.classList.remove('zkb-hide');
        send.classList.add('zkb-hide');
        ph.setAttribute('readonly', 'readonly');
      }

      function ask() {
        clear();
        var p = digits(ph.value);
        if (p.length !== 10) { fail('Enter your 10-digit mobile number'); ph.focus(); return; }
        PHONE = p;
        busy(send, true); busy(resend, true);
        post({ intent: 'send', phone: p }).then(function (r) {
          busy(send, false); busy(resend, false);
          if (!r || !r.ok) { fail((r && r.reason) || 'Could not send the code', r && r.detail); return; }
          otpBox.classList.remove('zkb-hide');
          otpBox.classList.remove('zkb-rev');
          void otpBox.offsetWidth;
          otpBox.classList.add('zkb-rev');
          code.focus();
          send.innerHTML = tick(15); send.classList.add('done');
          var lastBtn = ov.querySelector('#zkbLast');
          if (lastBtn) lastBtn.classList.add('zkb-hide');
        }).catch(function () { busy(send, false); busy(resend, false); fail('Network problem. Try again.'); });
      }
      send.addEventListener('click', ask);
      resend.addEventListener('click', ask);

      var lastOne = ov.querySelector('#zkbLast');
      if (lastOne) {
        lastOne.addEventListener('click', function () {
          ph.value = saved();
          PHONE = saved();
          ask();
        });
      }

      /* The code is checked when Continue is pressed, not while the digits
         are still being typed. A shopper mid-keystroke has not asked for
         anything yet, and a wrong guess counted against them for a digit
         they were about to correct is unfair. */
      var checking = false;
      function tryCode() {
        var c = digits(code.value);
        if (c.length !== 6 || checking) return;
        checking = true; clear();
        code.setAttribute('readonly', 'readonly');
        code.classList.add('zkb-chk');
        checkTip.classList.remove('zkb-hide');
        busy(next, true);

        function done() {
          checking = false;
          code.removeAttribute('readonly');
          code.classList.remove('zkb-chk');
          checkTip.classList.add('zkb-hide');
          busy(next, false);
        }

        post({ intent: 'verify', phone: digits(ph.value), code: c }).then(function (r) {
          if (!r || !r.ok) {
            done();
            fail((r && r.reason) || 'That code did not match');
            code.value = ''; code.focus();
            return;
          }
          VERIFIED = true; PHONE = digits(ph.value);
          remember(PHONE);
          /* the green seal takes the place of "Checking" for a beat before
             the page turns, so the shopper sees the code land */
          checkTip.classList.add('zkb-hide');
          okBox.classList.remove('zkb-hide');
          setTimeout(function () { done(); STEP = 2; render(); }, 700);
        }).catch(function () { done(); fail('Network problem. Try again.'); });
      }

      next.addEventListener('click', function () {
        clear();
        if (VERIFIED) { STEP = 2; render(); return; }
        if (digits(ph.value).length !== 10) { fail('Enter your 10-digit mobile number'); ph.focus(); return; }
        if (otpBox.classList.contains('zkb-hide')) {
          fail('Tap Send to get your code first');
          ask();
          return;
        }
        if (digits(code.value).length !== 6) { fail('Enter the 6-digit code'); code.focus(); return; }
        tryCode();
      });
      return;
    }

    /* step 2 - where it goes. Nothing is ordered here; the address is
       kept and the customer is shown what it costs before paying. */
    if (STEP === 2) {
      var f = ov.querySelector('#zkbF');

      // coming back from the payment screen should not mean typing it again
      if (ADDR) {
        f.firstName.value = ADDR.firstName;
        f.lastName.value = ADDR.lastName;
        f.address1.value = ADDR.address1;
        f.city.value = ADDR.city;
        f.zip.value = ADDR.zip;
        f.email.value = ADDR.email;
      }

      /* State, typed or tapped. A plain select on a phone opens the system
         wheel and, in this theme, paints itself a solid dark bar - so the
         field is an ordinary text box with a list under it. What Shopify
         stores is the two-letter code, which rides along hidden. */
      var stIn = ov.querySelector('#zkbSt'),
          stCode = ov.querySelector('#zkbStC'),
          stList = ov.querySelector('#zkbStL');

      if (ADDR && ADDR.province) {
        stCode.value = ADDR.province;
        stIn.value = stateName(ADDR.province);
      }

      function stHide() {
        stList.classList.add('zkb-hide');
        stIn.setAttribute('aria-expanded', 'false');
      }

      function stShow(q) {
        var t = String(q || '').trim().toLowerCase(), hit = [];
        for (var i = 0; i < STATES.length && hit.length < 40; i++) {
          if (!t || STATES[i][1].toLowerCase().indexOf(t) === 0) hit.push(STATES[i]);
        }
        if (t && !hit.length) {
          for (var j = 0; j < STATES.length && hit.length < 40; j++) {
            if (STATES[j][1].toLowerCase().indexOf(t) > 0) hit.push(STATES[j]);
          }
        }

        var h = '';
        if (!hit.length) {
          h = '<li class="none">No state by that name</li>';
        } else {
          for (var k = 0; k < hit.length; k++) {
            h += '<li role="option" data-c="' + hit[k][0] + '">' + esc(hit[k][1]) + '</li>';
          }
        }
        stList.innerHTML = h;
        stList.classList.remove('zkb-hide');
        stIn.setAttribute('aria-expanded', 'true');
      }

      stIn.addEventListener('focus', function () { stShow(stIn.value); });
      stIn.addEventListener('input', function () { stCode.value = ''; stShow(stIn.value); });

      stList.addEventListener('mousedown', function (e) {
        var li = e.target && e.target.closest ? e.target.closest('li[data-c]') : null;
        if (!li) return;
        e.preventDefault();
        stCode.value = li.getAttribute('data-c');
        stIn.value = stateName(stCode.value);
        stHide();
      });

      stIn.addEventListener('blur', function () {
        setTimeout(function () {
          // A name typed in full still counts, even if the list was ignored.
          if (!stCode.value) {
            var t = String(stIn.value || '').trim().toLowerCase();
            for (var i = 0; i < STATES.length; i++) {
              if (STATES[i][1].toLowerCase() === t) { stCode.value = STATES[i][0]; break; }
            }
          }
          if (stCode.value) stIn.value = stateName(stCode.value); else stIn.value = '';
          stHide();
        }, 140);
      });

      f.addEventListener('submit', function (e) {
        e.preventDefault(); clear();

        var need = ['firstName', 'address1', 'city'];
        for (var i = 0; i < need.length; i++) {
          if (!String(f[need[i]].value || '').trim()) {
            fail('Please fill in every box above'); f[need[i]].focus(); return;
          }
        }
        if (digits(f.zip.value).length !== 6) { fail('PIN code must be 6 digits'); f.zip.focus(); return; }
        if (!stCode.value) { fail('Please choose your state from the list'); stIn.focus(); return; }
        if (!VERIFIED) { fail('Please confirm your mobile number first'); STEP = 1; render(); return; }

        ADDR = {
          firstName: f.firstName.value, lastName: f.lastName.value,
          address1: f.address1.value, city: f.city.value,
          zip: digits(f.zip.value), province: stCode.value, email: f.email.value
        };
        STEP = 3; render();
      });
      return;
    }

    /* step 3 - how to pay. This is the last click of the whole flow, so
       choosing a method is what actually places the order or hands over
       to Shopify's checkout. */
    Array.prototype.forEach.call(ov.querySelectorAll('[data-pay]'), function (b) {
      b.addEventListener('click', function () {
        clear();
        if (!ADDR) { STEP = 2; render(); return; }
        PAY = b.getAttribute('data-pay');
        busy(b, true);

        var body = {
          intent: PAY === 'cod' ? 'place' : 'pay',
          items: D.lines.map(function (l) { return { variant: l.variant, quantity: l.quantity }; }),
          discountCode: D.discountCode || null,
          discountAmount: D.discountAmount || 0,
          subtotal: D.subtotal,
          firstName: ADDR.firstName, lastName: ADDR.lastName,
          address1: ADDR.address1, city: ADDR.city, province: ADDR.province,
          zip: ADDR.zip, email: ADDR.email, phone: PHONE
        };

        if (PAY !== 'cod') {
          /* Without Razorpay keys in the app, Shopify's checkout takes it
             from here, as it always did. */
          if (!CFG.pay) {
            ov.innerHTML = waitCard('Redirecting to checkout…');
            window.location.href = checkoutUrl();
            return;
          }
          payOnline(body);
          return;
        }

        ov.innerHTML = waitCard('Placing your order…');

        postBuy(body)
          .then(function (r) {
            if (!r || !r.ok) { STEP = 3; render(); late((r && r.reason) || 'Could not place the order'); return; }
            finish(r.name);
          })
          .catch(function () { STEP = 3; render(); late('Network problem. Please try again.'); });
      });
    });
  }

  function postBuy(body) {
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  /* The order is in. The same last screen whichever way it was paid -
     the tick, the chime, the cart emptied, and on to the order itself.
     Paid online or cash at the door, what the customer did is the same:
     they placed an order, and that is what the screen says. */
  function finish(name) {
    var to = '/account/orders?order=' + encodeURIComponent(name) + '&pin=' + encodeURIComponent(PHONE.slice(-4));
    ov.innerHTML = doneCard(name);
    guardLogo();
    chime();
    fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});
    setTimeout(function () { window.location.href = to; }, 2400);
  }

  /* ---------------------------------------------------------------- */
  /*  paying online, without leaving                                   */
  /* ---------------------------------------------------------------- */

  /* Razorpay's checkout script, fetched the first time it is needed. */
  var rzpLoad = null;
  function rzpScript() {
    if (window.Razorpay) return Promise.resolve(true);
    if (rzpLoad) return rzpLoad;
    rzpLoad = new Promise(function (go, no) {
      var sc = document.createElement('script');
      sc.src = 'https://checkout.razorpay.com/v1/checkout.js';
      sc.async = true;
      sc.onload = function () { go(true); };
      sc.onerror = function () { rzpLoad = null; no(new Error('razorpay script')); };
      document.head.appendChild(sc);
    });
    return rzpLoad;
  }

  /* The app opens a Razorpay order for the exact amount - worked out on
     the server from Shopify's own prices, never from this page - and hands
     back the key and the order id. Razorpay's checkout opens over the
     popup; when it closes with a signed receipt, the app is given the
     receipt and writes the order. */
  function payOnline(body) {
    ov.innerHTML = waitCard('Opening secure payment…');
    guardLogo();

    Promise.all([rzpScript(), postBuy(body)]).then(function (res) {
      var r = res[1];
      if (!r || !r.ok) { STEP = 3; render(); late((r && r.reason) || 'Could not open the payment'); return; }

      var rz = new window.Razorpay({
        key: r.key,
        amount: r.amount,
        currency: 'INR',
        order_id: r.order,
        name: 'Zakdor',
        description: r.description || 'Your order',
        image: LOGO,
        prefill: {
          name: ((ADDR.firstName || '') + ' ' + (ADDR.lastName || '')).trim(),
          email: ADDR.email || '',
          contact: '+91' + PHONE
        },
        theme: { color: '#1E4494' },
        modal: {
          ondismiss: function () {
            STEP = 3; render();
            late('The payment was not completed. Try again, or choose Cash on Delivery.');
          }
        },
        handler: function (p) { confirmPaid(r.order, p); }
      });
      rz.open();
    }).catch(function () {
      STEP = 3; render();
      late('Could not open the payment. Please try again.');
    });
  }

  /* Back from Razorpay with the receipt. If the app cannot be reached in
     that moment the money has still moved, so this keeps asking for a
     while - and the app's own clock job writes the order in any case. */
  function confirmPaid(order, p) {
    ov.innerHTML = waitCard('Confirming your payment…');
    guardLogo();
    postBuy({ intent: 'paid', order: order, payment: p.razorpay_payment_id, signature: p.razorpay_signature })
      .then(function (r) {
        if (r && r.ok) { finish(r.name); return; }
        waitForOrder(order, 0);
      })
      .catch(function () { waitForOrder(order, 0); });
  }

  function waitForOrder(order, n) {
    if (n >= 10) {
      ov.innerHTML = waitCard('Payment received. Your order confirmation will reach you on WhatsApp shortly.');
      guardLogo();
      fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});
      return;
    }
    setTimeout(function () {
      postBuy({ intent: 'status', order: order }).then(function (r) {
        if (r && r.ok && r.status === 'ordered' && r.name) { finish(r.name); return; }
        waitForOrder(order, n + 1);
      }).catch(function () { waitForOrder(order, n + 1); });
    }, 2500);
  }

  /* Shopify fills the checkout from the link itself: the items, the codes
     and the address the shopper just typed. Without this the checkout
     opened blank and everything had to be typed a second time. */
  function checkoutUrl() {
    var items = D.lines.map(function (l) { return l.variant + ':' + l.quantity; }).join(',');
    var codes = (D.discountCode ? D.discountCode + ',' : '') + (D.count === 1 ? PRE1 : CFG.code);
    var q = 'discount=' + encodeURIComponent(codes);
    function add(k, v) { if (v) q += '&' + k + '=' + encodeURIComponent(v); }
    if (ADDR) {
      add('checkout[email]', ADDR.email);
      add('checkout[shipping_address][first_name]', ADDR.firstName);
      add('checkout[shipping_address][last_name]', ADDR.lastName);
      add('checkout[shipping_address][address1]', ADDR.address1);
      add('checkout[shipping_address][city]', ADDR.city);
      add('checkout[shipping_address][province]', stateName(ADDR.province) || ADDR.province);
      add('checkout[shipping_address][zip]', ADDR.zip);
      add('checkout[shipping_address][country]', 'India');
      add('checkout[shipping_address][phone]', PHONE ? '+91' + PHONE : '');
    }
    return '/cart/' + items + '?' + q;
  }

  function late(msg) {
    var e = ov.querySelector('#zkbErr');
    if (e) { e.textContent = msg; e.classList.remove('zkb-hide'); }
  }

  /* ---------------------------------------------------------------- */
  /*  what is being bought                                             */
  /* ---------------------------------------------------------------- */

  var MODE = 'cart';

  function fromCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || !c.items || !c.items.length) return null;

        var lines = c.items.map(function (i) {
          return {
            variant: String(i.variant_id || i.id),
            quantity: Number(i.quantity) || 1,
            price: (Number(i.original_price != null ? i.original_price : i.price) || 0) / 100,
            title: i.product_title + (i.variant_title && i.variant_title !== 'Default Title' ? ' - ' + i.variant_title : ''),
            image: i.image || null
          };
        });

        var subtotal = 0, count = 0;
        for (var i = 0; i < lines.length; i++) {
          subtotal += lines[i].price * lines[i].quantity;
          count += lines[i].quantity;
        }

        var total = Number(c.total_price) / 100;
        if (!(total >= 0)) total = subtotal;
        var cut = Math.max(0, Math.round((subtotal - total) * 100) / 100);

        /* The pay-online code belongs to paying online. Once it has been
           applied to the cart it stays there, and it was then being counted
           against Cash on Delivery too - the saving showed at the top and
           came off the COD price, which is money the shop never agreed to
           give. Its share is added back, and the code is left out of the
           name shown, so only the shopper's own coupon counts here. */
        var pres = [String((CFG && CFG.code) || '').toUpperCase(), PRE1];
        function isPreCode(s) { s = String(s || '').toUpperCase(); return !!s && pres.indexOf(s) >= 0; }

        /* The codes on the cart, exactly as the shopper typed them. This is
           what gets shown - never a discount's name from the admin. */
        var codes = [], shopperCode = '';
        var dcs = c.discount_codes || [];
        for (var q = 0; q < dcs.length; q++) {
          if (!dcs[q] || !dcs[q].code || dcs[q].applicable === false) continue;
          var cd = String(dcs[q].code).toUpperCase();
          codes.push(cd);
          if (!isPreCode(cd) && !shopperCode) shopperCode = cd;
        }
        var preOn = false;
        for (var y = 0; y < codes.length; y++) if (isPreCode(codes[y])) preOn = true;

        /* either pay-online code may be sitting on the cart from an earlier
           try, whatever the count is now: Rs 20 an item, or the flat Rs 30 */
        var codeName = '', preAmt = 0, pre20 = count * 20 * 100, pre30 = 3000;
        var apps = c.discount_applications || c.cart_level_discount_applications || [];
        for (var k = 0; k < apps.length; k++) {
          if (!apps[k] || !apps[k].title) continue;
          var ttl = String(apps[k].title), isCode = apps[k].type !== 'automatic';
          var isPre = isCode && (isPreCode(ttl)
            || (preOn && (codes.length === 1 || Number(apps[k].total_allocated_amount) === pre20
              || Number(apps[k].total_allocated_amount) === pre30)));
          if (isPre) {
            preAmt += (Number(apps[k].total_allocated_amount) || 0) / 100;
          } else if (!codeName) {
            codeName = ttl;
          }
        }
        if (preAmt > 0) {
          total = Math.min(subtotal, total + preAmt);
          cut = Math.max(0, Math.round((subtotal - total) * 100) / 100);
        }
        var shown = shopperCode || (isPreCode(codeName) ? '' : codeName);

        return {
          lines: lines, count: count, subtotal: subtotal, discountAmount: cut,
          discountCode: cut > 0 ? shown : '', codes: codes, total: total,
          canPrepaidOff: !(cut > 0 && shown)
        };
      });
  }

  function chosen(el) {
    var form = el && el.closest ? el.closest('form[action*="/cart/add"]') : null;
    if (!form) form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    var v = id ? digits(id.value) : '';
    if (!v) return null;
    return { variant: v, quantity: Math.max(1, Math.min(10, Number(qty && qty.value) || 1)) };
  }

  function fromProduct(el) {
    var pick = chosen(el);
    if (!pick) return Promise.resolve(null);
    return fetch(API + '?json=1&v=' + encodeURIComponent(pick.variant), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.item) return null;
        var line = {
          variant: String(j.item.variant), quantity: pick.quantity,
          price: Number(j.item.price) || 0, title: j.item.title, image: j.item.image
        };
        var t = line.price * line.quantity;
        return {
          lines: [line], count: line.quantity, subtotal: t, discountAmount: 0,
          discountCode: '', codes: [], total: t, canPrepaidOff: true
        };
      });
  }

  /* ---------------------------------------------------------------- */
  /*  the buttons                                                      */
  /* ---------------------------------------------------------------- */

  var CART_GO = '[name="checkout"],.cart__checkout-button,a[href="/checkout"],a[href^="/checkout?"]';
  var BUY_NOW = '.shopify-payment-button__button,[data-zkb-buy]';
  var HOLD = 1300;

  function start(mode, el) {
    MODE = mode;
    STEP = 1; PAY = 'prepaid';
    setTimeout(function () {
      var l = document.querySelectorAll('.ax-busy,.axl-b');
      for (var i = 0; i < l.length; i++) l[i].classList.remove('ax-busy', 'ax-busy--solo', 'axl-b');
    }, 30);

    open();
    ov.innerHTML = waitCard('Getting your cart details…');
    guardLogo();

    var began = Date.now();
    var job = mode === 'cart' ? fromCart() : fromProduct(el);

    job.then(function (dd) {
      setTimeout(function () {
        if (!dd || !dd.lines.length) { close(); return; }
        D = dd;
        render();
        celebrateOnce(dd.discountCode, dd.discountAmount);
      }, Math.max(0, HOLD - (Date.now() - began)));
    }).catch(function () { close(); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.zkb-ov') || e.target.closest('.zkb-sheet')) return;

    var go = e.target.closest(CART_GO);
    if (go && !go.disabled) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (CFG) { start('cart', go); return; }
      /* The answer is not in yet. The popup opens on its waiting card right
         away rather than leaving the button dead for a second or two, which
         read as the site having frozen. If the app really is off, this is
         where Shopify's own checkout takes over, as it always did. */
      open();
      ov.innerHTML = waitCard('Getting your cart details…');
      guardLogo();
      ready().then(function (on) {
        if (on) start('cart', go);
        else { close(); window.location.href = '/checkout'; }
      });
      return;
    }
    var buy = e.target.closest(BUY_NOW);
    if (buy && !buy.disabled && document.querySelector('form[action*="/cart/add"]')) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (CFG) { start('product', buy); return; }
      /* Same hold as the cart button. If the app turns out to be off, the
         cart permalink is where Shopify's own Buy it now used to go: the
         checkout, with this item in it. */
      var pick = chosen(buy);
      open();
      ov.innerHTML = waitCard('Getting your cart details…');
      guardLogo();
      ready().then(function (on) {
        if (on) start('product', buy);
        else { close(); window.location.href = pick ? '/cart/' + pick.variant + ':' + pick.quantity : '/cart'; }
      });
    }
  }, true);

  /* Our Buy it now, drawn the moment the page is parsed. Shopify's own is
     switched off in the theme (the accelerated-checkout block is disabled
     in the product template), so there is nothing to swap and nothing to
     flash; should it ever be switched back on, it is hidden here so the
     page never shows two. */
  function addBuyNow() {
    if ((window.location.pathname || '').indexOf('/products/') < 0) return;
    if (document.querySelector('[data-zkb-buy]')) return;
    var atc = document.querySelector('add-to-cart-component button[name="add"],button[name="add"]');
    if (!atc) return;
    styles();
    var dyn = document.querySelectorAll('.shopify-payment-button');
    for (var d = 0; d < dyn.length; d++) dyn[d].style.setProperty('display', 'none', 'important');
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('data-zkb-buy', '1');
    b.className = 'zkb-b';
    b.style.marginTop = '10px';
    b.innerHTML = lock(15) + '<span>Buy it now</span>';
    var host = atc.closest('add-to-cart-component') || atc;
    if (host.parentNode) host.parentNode.insertBefore(b, host.nextSibling);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addBuyNow);
  else addBuyNow();
  /* the theme redraws the buy box on a variant change and in the editor */
  document.addEventListener('shopify:section:load', addBuyNow);
  setTimeout(addBuyNow, 900);
  setTimeout(addBuyNow, 2400);
})();